import React from 'react';
import './SummaryPopup.css';

export const SummaryPopupDesc = ({ classes, onConfirm, onCancel }) => {
  return (
    <div className="summary-popup">
      <div className="summary-content">
        <h2>Summary</h2>
        <div className="summary-list">
          {classes.map(cls => (
            <div key={`${cls.id}-${cls.is_peak}-${cls.price}`} className="summary-item">
              <strong>ID:</strong> {cls.id}<br />
              <strong>名称:</strong> {cls.name}<br />
              <strong>高/低峰:</strong> {cls.is_peak ? '高峰' : '低峰'}<br />
              <strong>价格:</strong> {cls.price}<br />
              <strong>更改类型：</strong> {cls.action ? '发布' : '下架'} <br />
            </div>
          ))}
        </div>
        <div className="button-container">
          <button className="confirm-button" onClick={onConfirm}>确认</button>
          <button className="cancel-button" onClick={onCancel}>取消</button>
        </div>
      </div>
    </div>
  );
};

const SummaryPopupClass = ({ classes, inputValues, onConfirm, onCancel }) => {
  return (
    <div className="summary-popup">
      <div className="summary-content">
        <h2>Summary</h2>
        <div className="summary-list">
          {classes.map(cls => (
            <div key={`${cls.id}_${cls.updated_at}`} className="summary-item">
              <strong>ID:</strong> {cls.id}<br />
              <strong>名称:</strong> {cls.name}<br />
              <strong>课程日期:</strong> {cls.class_date}<br />
              <strong>场馆:</strong> {cls.studio}<br />
              <strong>教练:</strong> {cls.instructor['name']}<br />
              <strong>分配名额:</strong> {inputValues[`${cls.id}_${cls.updated_at}`]}<br />
              <strong>操作：</strong> {cls.cancelled === 2 ? '取消' : (cls.tab === 'post' ? '发布' : '更新')} <br />
            </div>
          ))}
        </div>
        <div className="button-container">
          <button className="confirm-button" onClick={onConfirm}>确认</button>
          <button className="cancel-button" onClick={onCancel}>取消</button>
        </div>
      </div>
    </div>
  );
};

export default SummaryPopupClass;


